export default __webpack_public_path__ + "static/media/1481.33082fac.png";